<chat
  [contact]="contact"
  [disabled]="disabled"
  [forceLtr]="forceLtr"
  (onSendMsg)="onSendMsg($event)"
  (onChatRefreshRequest)="onChatRefresh($event)"
  (onFileClicked)="onFileMsgClicked($event)"
  (onDeleteMsgClicked)="onDeleteMsgClicked($event)"
  (onCreateTaskClicked)="onCreateTaskClicked($event)"
></chat>

<p-dialog
  *ngIf="
    selectedFile &&
    store.selectSignal(currentDisplayedFileId)() === selectedFile.fileId
  "
  [(visible)]="filePopupDisplay"
  [modal]="false"
  [draggable]="true"
  [resizable]="true"
  [closable]="false"
  (onHide)="
    filePopupDisplay = false;
    selectedFile = null;
    store.dispatch(CLEAR_DISPLAYED_FILE())
  "
>
  <file-preview
    [fileList]="[selectedFile]"
    [currentFile]="selectedFile"
    (onClose)="filePopupDisplay = false; selectedFile = null"
    [showSendInChat]="false"
    [showDelete]="false"
  ></file-preview>
</p-dialog>
